import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Paths } from '../../shared/paths';
import Statistics from './statistics/Statistics';
import StatisticsDay from './statistics/statistics-day/StatisticsDay';

export default function StatisticsRouter() {
  return (
    <Routes>
      <Route
        path={`${Paths.statistics.day}/:day`}
        element={<StatisticsDay />}
      />
      <Route path={`*`} element={<Statistics />} />
    </Routes>
  );
}
